import { rolesItems } from "./roles";

export const _ID_AGENCE_ES = 23;
export const _ID_AGENCE_ALL = 22;
export const _ID_CAISSE_ES = 2;
export const _ROLES = rolesItems;
